import { Box, Divider, Flex, Image, Spinner } from "@chakra-ui/react";
import { Sidebar } from "@root/components/dashboard/sidebar";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { DashboardLayoutContainter } from "./styles";
import UnauthenticatedHeader from "@root/components/UnauthenticatedDashboard/UnauthenticatedHeader";
import useMediaQ from "@root/hooks/useMediaQ";
import HamburgerButton from "@root/components/common/HamburgerButton";
import { GuestMobileSideMenu } from "@root/components/dashboard/sidebar/GuestMobileSideMenu";
import { useOrganizationBranding } from "@root/context/organization-branding-context";
import { CommonFooter } from "@root/components/auth/commonFooter";

const UnauthenticatedLayout: React.FC = () => {
  const filePopOverStatus: boolean = true;
  const { sm } = useMediaQ();
  const isMobile = !sm;
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const { logoUrl, defaultLogoUrl, loading } = useOrganizationBranding();

  const globalClickHandlet = () => {
    if (filePopOverStatus) {
    }
  };
  return (
    <DashboardLayoutContainter onClick={globalClickHandlet}>
      <Flex flex={1} width={"100%"}>
        {!isMobile && (
          <Box className="left-box" p={"12px"}>
            <Sidebar />
          </Box>
        )}

        {/* Vertical Divider */}
        {!isMobile && (
          <Divider orientation="vertical" borderColor="gray.300" height="100%" />
        )}

        <Flex flex={1} bgColor={"#A7BBC80F"} flexDirection={"column"}>
          <Flex
            overflowY={"auto"}
            className="right-box"
            flex={1}
            flexDir={"column"}
          >
            {isMobile ? (
              <Flex
                justify="space-between"
                alignItems="center"
                w="100%"
                height="68px"
                px="24px"
                borderBottom="1px solid"
                borderColor="#CDD6DC"
                bgColor={"#EEEEF9"}
              >
                <Flex alignItems="center" gap="12px">
                  <HamburgerButton onClick={() => setIsSideMenuOpen(true)} mr="0px" />
                  {loading ? (
                    <Spinner size="md" />
                  ) : (
                    <Image
                      src={logoUrl || defaultLogoUrl}
                      alt="Logo"
                      maxH="38px"
                      objectFit="contain"
                    />
                  )}
                </Flex>
              </Flex>
            ) : (
              <Box w="100%">
                <UnauthenticatedHeader />
              </Box>
            )}
            <Box flex={1} overflowY="auto">
              <Outlet />
            </Box>
          </Flex>
          <CommonFooter />
        </Flex>
      </Flex>

      {/* Guest Mobile Side Menu */}
      {isMobile && (
        <GuestMobileSideMenu
          isOpen={isSideMenuOpen}
          onClose={() => setIsSideMenuOpen(false)}
        />
      )}
    </DashboardLayoutContainter>
  );
};

export default UnauthenticatedLayout;
